import { Rating, SxProps, Theme } from '@mui/material';
import { FC } from 'react';

interface Props {
  name?: string | undefined;
  value: number | null | undefined;
  size?: 'small' | 'medium' | 'large' | undefined;
  sx?: SxProps<Theme>;
}

const StarRating: FC<Props> = ({ name, value, size, sx }) => {
  return (
    <Rating
      name={name || 'read-only'}
      value={value}
      max={5}
      precision={0.5}
      readOnly
      size={size}
      sx={{ ...sx }}
    />
  );
};

export default StarRating;
